<app-transaction-result-view
[shouldShowFlow]="false"
title="Historial de solicitudes"
[subtitle]="subtitle"
[message]="message"
actionButtonText="Volver a mi perfil"
actionButtonPath="/verification/requests"
[breadcrums]="breadcrums"
[variant]="variant"
></app-transaction-result-view>
